import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import {AuthenticationService} from "./_services/authentication.service";

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router,
    //private serverData: ServerDataService,
    private authService: AuthenticationService){
  }



  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isAuthenticated()){
      console.debug("authenticated user");
      return true;
    }
    console.debug("not authenticated user");
    // not logged in so redirect to login page with the return url
    this.router.navigate(['/login']);
    return false;

}
}



// WEBPACK FOOTER //
// ./src/app/auth.guard.ts